/**
 * 广告
 */
import { KLICENADLIST } from '../types';

export default {
    name: `${KLICENADLIST}`,
    path: '/klicenAdList',
    component: () => import(/* webpackChunkName: 'klicenAdList' */ '@/views/klicenAdList/'),
    redirect: { name: `${KLICENADLIST}Index` },
    meta: {
        title: '凯励程广告',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${KLICENADLIST}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'klicenAdList' */ '@/views/klicenAdList/home/Home.vue'),
        },
        // 广告详情
        {
            name: `${KLICENADLIST}Detail`,
            path: 'detail/:id',
            component: () => import(/* webpackChunkName: 'klicenAdListDetail' */ '@/views/klicenAdList/detail/Detail.vue'),
        },
        // 创建广告
        {
            name: `${KLICENADLIST}Create`,
            path: 'create',
            component: () => import(/* webpackChunkName: 'klicenAdListCreate' */ '@/views/klicenAdList/create/Create.vue'),
        },
        // 编辑广告投放范围
        {
            name: `${KLICENADLIST}Scope`,
            path: 'scope',
            component: () => import(/* webpackChunkName: 'klicenAdListScope' */ '@/views/klicenAdList/scope/Scope.vue'),
        },
    ],
};
